export const FETCH_VOLUNTEER_DASHBOARD_EVENTS_BEGIN = 'FETCH_VOLUNTEER_DASHBOARD_EVENTS_BEGIN'
export const FETCH_VOLUNTEER_DASHBOARD_EVENTS_ERROR = 'FETCH_VOLUNTEER_DASHBOARD_EVENTS_ERROR'
export const FETCH_VOLUNTEER_DASHBOARD_EVENTS_SUCCESS = 'FETCH_VOLUNTEER_DASHBOARD_EVENTS_SUCCESS'

export const FETCH_VOLUNTEER_DASHBOARD_TEAMS_BEGIN = 'FETCH_VOLUNTEER_DASHBOARD_TEAMS_BEGIN'
export const FETCH_VOLUNTEER_DASHBOARD_TEAMS_ERROR = 'FETCH_VOLUNTEER_DASHBOARD_TEAMS_ERROR'
export const FETCH_VOLUNTEER_DASHBOARD_TEAMS_SUCCESS = 'FETCH_VOLUNTEER_DASHBOARD_TEAMS_SUCCESS'
